"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var app_1 = require("../app");
var react_router_dom_1 = require("react-router-dom");
var classnames_1 = __importDefault(require("classnames"));
var useContext = react_1.default.useContext;
exports.default = (function (_a) {
    var context = useContext(app_1.CheckoutContext);
    if (!context)
        return null;
    var location = (0, react_router_dom_1.useLocation)();
    var shippingComplete = !!context.shippingAddress;
    var shippingSelected = location.pathname === '/';
    var paymentSelected = location.pathname === '/payment';
    return (react_1.default.createElement("div", { className: 'checkout-steps grid-x font-size-12' },
        react_1.default.createElement("span", { className: (0, classnames_1.default)({ 'font-bold': shippingSelected }) },
            shippingComplete && react_1.default.createElement(react_router_dom_1.Link, { to: '/' }, "Shipping"),
            !shippingComplete && 'Shipping'),
        "\u00A0\u00A0>\u00A0\u00A0",
        react_1.default.createElement("span", { className: (0, classnames_1.default)({ 'font-bold': paymentSelected }) }, "Payment")));
});
